import SquareCTA from './SquareCTA';

export default SquareCTA;
